import * as yup from 'yup';

export const validations = yup.object().shape({
  restrictionTypePrice:
    yup
    .string()
    .required('Selecione uma tabela para continuar')
    .nullable()
});